var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgConnectorIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.59 5H15.25V2C15.25 1.59 14.91 1.25 14.5 1.25C14.09 1.25 13.75 1.59 13.75 2V5H10.25V2C10.25 1.59 9.91 1.25 9.5 1.25C9.09 1.25 8.75 1.59 8.75 2V5H8.41C7.36 5 6.5 5.86 6.5 6.91V12C6.5 14.2 8 16 10.5 16H11.25V22C11.25 22.41 11.59 22.75 12 22.75C12.41 22.75 12.75 22.41 12.75 22V16H13.5C16 16 17.5 14.2 17.5 12V6.91C17.5 5.86 16.64 5 15.59 5Z",
    fill: "url(#paint0_linear_8002_71181)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_8002_71181",
    x1: 12,
    y1: 1.25,
    x2: 12,
    y2: 22.75,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#39B6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0D88D0"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConnectorIcon);
export default __webpack_public_path__ + "static/media/connector-icon.1adcbd453ad72cc530b0c11cc4852282.svg";
export { ForwardRef as ReactComponent };